import { styled, Box } from '@material-ui/core';

export const VideoItemCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  maxHeight: 214,
  maxWidth: 333,
  minHeight: 214,
  minWidth: 333,
  borderRadius: 8,
  margin: 10,
  '& .profile-video-item': {
    width: '100%',
    borderRadius: 10,
  },
  position: 'relative',

  [theme.breakpoints.down(960)]: {
    maxHeight: 'unset',
    maxWidth: 'unset',
    minHeight: 'unset',
    minWidth: 'unset',
  },
}));

export const MainCont = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-around',
  height: '100%',
  alignContent: 'flex-start',
}));
